module.exports = __webpack_public_path__ + "img/d6.ca04057b.png";